import React, { FC } from 'react';
import Form from 'components/Form';

import { HuskyxPageProps } from './models';

import 'styles/main.scss';
import './styles.scss';

const Huskyx: FC<HuskyxPageProps> = ({ pageContext, location }) => (
  <Form {...{ ...pageContext, location }} />
);

export default Huskyx;
